import { Injectable } from '@angular/core';
import { StorageService } from './storage.service';

@Injectable()
export class SessionStorageService extends StorageService {
  public override read(key: string): any {
    const generatedKey: string = this.getKey(key);
    const value: string | null = sessionStorage.getItem(generatedKey);
    // Typescript and Angular disagree on the type returned by sessionStorage causing a build error
    // so we explicitly declared the value type

    if (value !== null && value !== undefined) {
      return JSON.parse(value);
    }

    return undefined;
  }

  public override remove(key: string): void {
    sessionStorage.removeItem(this.getKey(key));
  }

  /**
   * Deletes all the keys from the storage service created by csx-security (i.e. keys with clientId as prefix)
   */
  public override clear(): void {
    Object.keys(sessionStorage)
      .filter(key => key?.endsWith(this.postfix))
      .forEach(key => {
        this.remove(key);
      });
  }
  public override write(key: string, value: any): void {
    sessionStorage.setItem(this.getKey(key), JSON.stringify(value));
  }
}
